import { render, staticRenderFns } from "./AppConfiguration.vue?vue&type=template&id=b9a38a32&scoped=true"
import script from "./AppConfiguration.vue?vue&type=script&lang=js"
export * from "./AppConfiguration.vue?vue&type=script&lang=js"
import style0 from "./AppConfiguration.vue?vue&type=style&index=0&id=b9a38a32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a38a32",
  null
  
)

export default component.exports